export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component('Vue3Lottie', import.meta.client
    ? defineAsyncComponent(() => import('vue3-lottie').then(m => m.Vue3Lottie))
    // noop
    : defineAsyncComponent(() => new Promise(() => {})))
})
